<script setup>
defineProps({
  modelValue: {
    required: true
  },
  label: String,
  id: String,
  placeholder: String,
  required: Boolean,
  disabled: Boolean,
  isPlaceholderHidden: Boolean,
  items: Array,
  format: Function,
  itemTitle: {
    type: Function,
    default: () => undefined
  },
  value: Function
})

const emit = defineEmits(['update:modelValue'])

const onChange = (event) => {
  const raw = event.target.value

  let parsed

  if (!isNaN(Number(raw))) {
    parsed = Number(raw)
  } else if (raw === 'true' || raw === 'false') {
    parsed = raw === 'true'
  } else {
    parsed = raw
  }

  emit('update:modelValue', parsed)
}
</script>

<template>
  <div class="flex flex-col gap-2 bg-white rounded border p-2 overflow-hidden">
    <slot>
      <label v-if="label" :for="label" class="flex gap-1 text-xs font-light opacity-75">
        <span>{{ label }}</span>
        <span v-if="!required" class="lowercase">({{ $t('labels.optional') }})</span>
      </label>
    </slot>
    <div class="relative flex items-center" :class="{ 'pointer-events-none opacity-50': disabled }">
      <select
        :id="id || label"
        class="w-full font-normal appearance-none"
        :value="modelValue"
        :required
        @change="onChange"
      >
        <option class="!text-black" v-if="placeholder" :hidden="isPlaceholderHidden" :value="0">
          {{ placeholder }}
        </option>
        <option
          class="!text-black"
          v-for="(item, index) in items"
          :key="value(item)"
          :value="value(item, index)"
          :title="itemTitle(item, index)"
          :hidden="item.hidden"
        >
          {{ format(item, index) }}
        </option>
      </select>
      <i
        class="bg-inherit pl-2 absolute fal fa-chevron-down text-xs text-gray-600 font-light pointer-events-none right-0"
      />
    </div>
  </div>
</template>
